import _ from 'lodash'

let { protocol, pathname } = window.location

pathname = _.trimEnd(pathname, '/')
pathname = pathname.replace('index.php', '')

// let api_root = protocol + '//' + document.domain + '/' + _.trimStart(pathname, '/')
// let baseUrl = _.trimEnd(api_root) + '/index.php'

let baseUrl = _.trimEnd(protocol + '//' + document.domain, '/') + '/' + _.trimStart(pathname, '/')

export const DEV_BASE_URL = 'api'

export const BASE_URL = baseUrl

export default {
  URL: process.env.NODE_ENV === 'development' ? DEV_BASE_URL : baseUrl,
}

window.console.log('当前的环境：', process.env.NODE_ENV);
